var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemWarningDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3 4a1 1 0 0 1 1-1h15.111A2.88 2.88 0 0 1 22 5.875v12.25C22 19.72 20.7 21 19.111 21H7.778a2.88 2.88 0 0 1-2.89-2.875V14.64a1 1 0 1 1 2 0v3.485c0 .476.392.875.89.875H19.11a.88.88 0 0 0 .889-.875V5.875A.88.88 0 0 0 19.111 5H4a1 1 0 0 1-1-1m1 3.5a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1M4 10a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm10-2.5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1m1 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0",
  clipRule: "evenodd"
})));
export default SvgGemWarningDelivery;